<template>
  <section class="userAdd">
    <el-dialog
      :title="id ? '编辑' : '添加'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="60%"
      @close="cancelSubmit"
    >
      <div class="userAdd-content">
        <el-form
          ref="info"
          :model="info"
          :rules="rules"
          status-icon
          label-position="left"
          label-width="80px"
        >
          <el-form-item prop="name" label="姓名：">
            <el-input
              v-model="info.name"
              type="text"
              auto-complete="off"
              placeholder="请输入姓名"
              clearable
            />
          </el-form-item>
          <el-form-item prop="remark" label="备注：">
            <el-input
              v-model="info.remark"
              auto-complete="off"
              placeholder="请输入备注"
              clearable
              type="textarea"
              :rows="4"
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="userAdd-foot">
        <el-button @click="cancelSubmit">
          取 消
        </el-button>
        <el-button type="primary" @click="handleSubmit">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import mock from '@/utils/mock'
import api from '@/api/app'
export default {
  name: 'ComUserAdd',
  components: {},
  props: {
    value: Boolean,
    id: Number,
    rules: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      mineInfo: mock.mine.set.viewInfo,
      mineInit: mock.mine.set.init,
      info: {
        name: '',
        remark: ''
      }
    }
  },
  watch: {
    value: {
      handler(val) {
        this.dialogVisible = val
        if (this.id) {
          this.init(val)
        } else {
          this.info = {
            name: '',
            remark: ''
          }
        }
      }

    }
  },
  mounted() {},
  methods: {
    async init() {
      if (this.id) {
        const _this = this
        const arr = await _this.mineInit.data1()
        _this.info = arr[arr.findIndex((item) => item.id == _this.id)]
      }
      this.loading = false
    },
    handleSubmit() {
      this.$refs.info.validate((valid) => {
        if (valid) {
          if (this.id) {
            api.mine.update.user(this.info).then((res) => {
              this.$message.success('编辑成功')
            })
          } else {
            api.mine.create.user(this.info).then((res) => {
              this.$message.success('添加成功')
            })
          }
          this.cancelSubmit()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    cancelSubmit: function() {
      this.info = {
        name: '',
        remark: ''
      }
      this.dialogVisible = false
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped >
.userAdd {
  &-content {
    height: 100%;
    text-align: center;
  }
}
</style>

